import { ModelContext } from './ModelContext';
import { PriceModel } from './Price.model';
import { cartV2 } from '@wix/ecom';

export enum DiscountScope {
  DELIVERY = 'DELIVERY',
  LINE_ITEM = 'LINE_ITEM',
  CART_SUBTOTAL = 'CART_SUBTOTAL',
}

const discountScopeV2ToDiscountScope = {
  [cartV2.DiscountScope.LINE_ITEM]: DiscountScope.LINE_ITEM,
  [cartV2.DiscountScope.DELIVERY]: DiscountScope.DELIVERY,
  [cartV2.DiscountScope.CART_SUBTOTAL]: DiscountScope.CART_SUBTOTAL,
  [cartV2.DiscountScope.UNKNOWN_DISCOUNT_SCOPE]: undefined,
};

export class LineItemDiscountModel {
  public lineItemIds?: string[];
  public amountOff?: PriceModel;
  public scope?: DiscountScope;
  public isAutomaticDiscount: boolean;

  constructor(params: LineItemDiscountModel) {
    this.lineItemIds = params.lineItemIds;
    this.amountOff = params.amountOff;
    this.scope = params.scope;
    this.isAutomaticDiscount = params.isAutomaticDiscount;
  }

  public static fromV2(
    discount: cartV2.Discount,
    lineItemDiscount: cartV2.V2LineItemDiscount,
    modelContext: ModelContext,
  ) {
    return new LineItemDiscountModel({
      lineItemIds: lineItemDiscount.lineItemId
        ? [lineItemDiscount.lineItemId]
        : /* istanbul ignore next */ undefined,
      amountOff: PriceModel.fromV2(lineItemDiscount.amountOff, modelContext),
      isAutomaticDiscount:
        discount.source?.sourceType ===
        cartV2.DiscountSourceType.AUTOMATIC_RULE,
      scope: discountScopeV2ToDiscountScope[discount.scope!],
    });
  }
}
